<template>
  <div class="header border-1px">
    <div class="header-left">
      <div class="header-left-title mr-5">{{title}}</div>
      <div class="header-left-txt mr-4">{{txt}}</div>
    </div>
    <v-btn
      class="back-btn border-1px"
      depressed
      @click="()=>{$router.go(-1)}"
    >{{$t('actions.back')}}</v-btn>
  </div>
</template>

<script>
export default {
  name: 'certification-header',
  components: {},
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    txt: {
      type: String,
      default: ''
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {}
};
</script>

<style lang="stylus" scoped>
.header {
  padding: 0 20px 0 30px;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &-left {
    display: flex;
    align-items: center;

    &-title {
      font-size: 16px;
      color: #333;
    }

    &-txt {
      font-size: 14px;
      color: #8A909A;
    }
  }

  .back-btn {
    height: 32px;
    background-color: #fff !important;
  }
}
</style>
